import React, { ChangeEvent, memo, useState } from 'react'

import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { CheckboxProps } from '@mui/material/Checkbox'

import { RoundCheckboxWrapper, StyledCheckbox } from './index.styles'

const CustomRoundCheckbox = (props: CheckboxProps) => {
  const { checked, onChange, id } = props
  const [localChecked, setLocalChecked] = useState<boolean | null>(null)

  return (
    <RoundCheckboxWrapper>
      <StyledCheckbox
        id={id}
        icon={<RadioButtonUncheckedIcon data-testid="RadioButtonUncheckedIcon" />}
        checkedIcon={<CheckCircleIcon data-testid="CheckCircleIcon" />}
        checked={localChecked ?? checked}
        onChange={(e: ChangeEvent<HTMLInputElement>, v: boolean) => {
          setLocalChecked(v)
          onChange?.(e, v)
        }}
      />
    </RoundCheckboxWrapper>
  )
}

export default memo(CustomRoundCheckbox)
